export const apiPath = '/v2/visit_requests';
const actionType = 'VISIT_REQUESTS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
